// Node modules
import { Container, delayedCall, ingenuity, killDelayedCall } from "@quest/base-core";
import {
  SlotConstantsBehavior,
  MeterBehavior,
  BigWinControllerFg,
  BigWinViewFg,
  SoundConstant,
} from "@quest/murka-games-behavior-leopard/dist";

// Game modules
import { Emitter } from "@quest/pixi-bridge/dist/Particles/Emitter";
import { Linear } from "@quest/pixi-bridge/dist/easing/Easing";

export class BigWinControllerFgGame extends BigWinControllerFg {
  protected view: BigWinViewFg;
  // private fgBigWinBgPortraitSpine: SpineBase;
  protected freeSpinBigWinMeter:any
  private emitter: Emitter;
  private coinShowerContainerMask: any;

  /**
   * Override to initialize free spin big win elements
   */
  protected initializeFSBigWinElements() {
        this.freeSpinBigWinContainer = this.view.getContainerByID("fsBigWinMeterContainer");
        this.freeSpinBigWinMeter = this.view.getMeterById("fsBigWinMtr") as MeterBehavior;
        this.freeSpinBigWinMainContainer = this.view.getContainerByID("fsBigWinMainContainer");
        this.fgLoopSpine = this.view.getSpineById("freegame_big_Win");
        //!ingenuity.deviceEnv.isDesktop && this.initializePortraitComponent();
        this.coinShowerContainerMask = this.view.getShapeById("coinShowerContainerMask") as any;
        // this.coinShowerContainerMask.y = this.view.json.Y_POSITION[0];
        // if (!ingenuity.deviceEnv.isDesktop) {
        //   this.coinShowerContainerMask.y = this.view.json.Y_POSITION[1];
        // }
  }

  /**
   * Override to initialize free spin big win portrait elements
   */
  protected initializePortraitComponent() {
    this.fgPortraitLoopSpine = this.view.getContainerByID("fgBigWinPortraitContainerCharacter").children[0];
    // this.fgBigWinBgPortraitSpine = this.view.getContainerByID("fgBigWinPortraitContainerBG").children[0];
  }

  // Override to add to play portrait free spin big win
  protected playFgPortraitSpineInLoop() {
    // this.fgPortraitLoopSpine.visible = true;
    // this.fgBigWinBgPortraitSpine.visible = true;
    // this.fgBigWinBgPortraitSpine.playAnim("in_portrait_bg", false);
    // this.fgPortraitLoopSpine.playAnim("in_portrait", false);
    // this.fgPortraitLoopSpine.onComplete.addOnce(() => {
    //   this.fgPortraitLoopSpine.playAnim("loop_portrait", true);
    //   this.fgBigWinBgPortraitSpine.playAnim("loop_portrait_bg", true);
    // }, this);
  }

  /**
   * Override to play Bg loop spine
   */
  protected playFgSpineInLoop() {
        this.fgLoopSpine.visible = true;
        this.fgLoopSpine.playAnim("big_in_desktop_fg", false);
        this.fgLoopSpine.onComplete.addOnce(() => {
                  this.playCoinShower();
            this.fgLoopSpine.playAnim("big_loop_desktop_fg", true);
        }, this);
    }
  
  // Add to play coin shower
  private playCoinShower(): void {
    this.initializeCoinShowerEmitter();
    this.startCoinShowerEmitter();
    if (!ingenuity.deviceEnv.isDesktop) {
      // this.initPortraitCoinShowerEmitter();
      // this.startPortraitShowerEmitter();
    }
  }

    /**
     * Method to start the emitter
     * @returns
     */
    private startCoinShowerEmitter(): void {
      // this.coinShowerStarted = true;
      this.emitter = ingenuity.currentGame.particles.getEmitterById("winCoinEmitter");
      this.emitter.autoUpdate = true;
      this.emitter.emit = true;
    }

  /**
   * Initialize Data for Coin Shower Emmiter
   */
  private initializeCoinShowerEmitter(): void {
    const particleData: any = {
      emitterType: 1,
      id: "winCoinEmitter",
      autoStart: false,
      animConfig: [
        {
          framerate: 20,
          loop: true,
          image: "Coin_rotation",
          generateFrames: true,
          frames: [0, 14],
        },
      ],
    };
    const config = {
      alpha: {
        start: 1,
        end: 1,
      },
      scale: {
        start: 0.8,
        end: 1,
        minimumScaleMultiplier: 0.5,
      },
      speed: {
        start: 500,
        end: 500,
        minimumSpeedMultiplier: 2,
      },
      acceleration: {
        x: 0,
        y: 200,
      },
      maxSpeed: 0,
      startRotation: {
        min: -140,
        max: -50,
      },
      noRotation: true,
      rotationSpeed: {
        min: 0,
        max: 0,
      },
      lifetime: {
        min: 3,
        max: 5,
      },
      blendMode: "normal",
      frequency: 0.05,
      emitterLifetime: -1,
      maxParticles: 150,
      pos: {
        x: 0,
        y: 0,
      },
      addAtBack: false,
      spawnType: "point",
    };
    const coinShowerContainer: Container = this.view.getContainerByID("coinShowerContainer");
    coinShowerContainer && (coinShowerContainer.mask = this.coinShowerContainerMask);
    ingenuity.currentGame.add.emitter(coinShowerContainer, particleData, config) as Emitter;
//     if(!ingenuity.deviceEnv.isDesktop ){
//       const coinShowerContainerPort: Container = this.view.getContainerByID("coinShowerContainerPort");
//       ingenuity.currentGame.add.emitter(coinShowerContainerPort, particleData, config) as Emitter;
// }

  }


    // Override to add to play desktop free spin big win end animation
    protected stopFgSpineInLoop() {
       this.fgLoopSpine.playAnim("big_out_desktop_fg", false);
        this.fgLoopSpine.onComplete.addOnce(() => {
           this.fgLoopSpine.visible = false;
        }, this);
  }

    /**
     * Add to show and move free spin big win meter mid of reel
     */
   protected showFSBigWinTickup():void {
      this.freeSpinBigWinContainer.visible = true;
      this.freeSpinBigWinContainer.x = this.freeSpinBigWinContainer.json.initialX;
      const moveTween = ingenuity.currentGame.add.tween(this.freeSpinBigWinContainer).to({ x: this.freeSpinBigWinContainer.json.finalX }, SlotConstantsBehavior.TICKUP_MOVE_IN_LEFT_DURATION, Linear.None, true, 0, 0, false);
      moveTween.onComplete.addOnce(() => {
          this.startFSBigWinTickup();
          moveTween.stop();
          ingenuity.currentGame.tweens.remove(moveTween);
      }, this);
  }

  // Override to add to false the visibility of portrait free spin big win end animation
  protected stopFgPortraitSpineInLoop() {
    // this.fgPortraitLoopSpine.visible = false;
    // this.fgBigWinBgPortraitSpine.visible = false;
  }

  /**
   * Called after tickup complete and stage click case
   */
  protected freeSpinBigWinPresentationComplete(): void {
    delayedCall(
      SlotConstantsBehavior.FS_BIG_WIN_METER_MOVE_DELAY,
      SlotConstantsBehavior.DURATION_1200,
      () => {
        killDelayedCall(SlotConstantsBehavior.FS_BIG_WIN_METER_MOVE_DELAY);
        this.moveFSBigWinMeterInLeft();
        ingenuity.soundManager.stop(SoundConstant.WIN_SOUND_FG_3, "soundList_1");
        if (ingenuity.deviceEnv.isDesktop) {
          this.stopFgSpineInLoop();
        } else {
          this.stopFgSpineInLoop();
          this.stopFgPortraitSpineInLoop();
        }
      },
      this
    );
  }
  // Overrided to set meter value zero at the start of free spin
  protected startFSBigWin(): void {
    super.startFSBigWin();
    this.freeSpinBigWinMeter.setValue(0);
  }
      /**
     * Called when Fg stage click
     */
      protected  stopFSBigWinAndTicker():void {
         this.freeSpinBigWinMeter.stopTick(false, true, true);
         this.freeSpinBigWinMeter.setCurrencyFormattedValue(String(this.currentWinAmountTickUpFg));
         this.freeSpinBigWinPresentationComplete();
     }
      
     // code removed to remove mask from big win fg 
  protected createMask(): void {
    //
  }

  protected resetFSBigWinElements():void{
    super.resetFSBigWinElements();
        if (this.emitter) {
      this.emitter.emit = false;
      this.emitter.autoUpdate = false;
      this.emitter.destroy();
    }
  }
}
